import React from "react";
import PropTypes from "prop-types";

const BrandIcon = ({
  className,
  width,
  size,
  height,
  style,
  color,
  noPointer,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 20}
    height={height || size || 20}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
    fill={color || "black"}
    stroke={color || "black"}
  >
    <title>{title}</title>
    <g stroke="none" fill="none" fillRule="evenodd">
      <path d="M-2-2h24v24H-2z" />
      <g fill={color || "#57595D"} fillRule="nonzero">
        <path d="M1.841 15.54A1 1 0 0 1 .16 14.46l9-14a1 1 0 0 1 1.682 0l9 14a1 1 0 0 1-1.682 1.08L10 2.85 1.841 15.54z" />
        <path d="M3.462 15L10 17.906 16.538 15 10 12.094 3.462 15zm6.944-4.914l9 4c.792.352.792 1.476 0 1.828l-9 4a1 1 0 0 1-.812 0l-9-4c-.792-.352-.792-1.476 0-1.828l9-4a1 1 0 0 1 .812 0z" />
      </g>
    </g>
  </svg>
);
BrandIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default BrandIcon;
